export default "__VITE_ASSET__6mYI1PpZ__"